/**
 * List
 */

import Config from '../Config';
import Util from '../Util';
import Search from './Search';
import Template from './Template';
import Loading from '../Loading';
import DropdownLayer from '../DropdownLayer';
import ParamInfo from './ParamInfo';
import ListCategory from './ListCategory';
import ListSizeChanger from './ListSizeChanger';
import PageNavigation from './PageNavigation';
import ListTopUtil from './ListTopUtil';
import NoticeList from './NoticeList';
import GameInfo from '../GameInfo';
import ArticleDelete from './my/ArticleDelete';
import BookmarkDelete from './my/BookmarkDelete';
import User from '../User';

import RXJS from './playground/RXJS';

class List {

	public onLoaded: any;

	public paramInfo: ParamInfo;

	protected viewMode: string;

	protected listId: string = 'ncCommunityBoardList';

	protected loading: Loading;

	protected isFirstLoaded: boolean = false;

	protected search: Search;

	protected pageNavigation: PageNavigation;

	protected $node: any;

	protected _id: string;

	private listData: any = {};

	private listTopUtil: ListTopUtil;

	private size: number;

	constructor( node: any, options: any ) {
		this.$node = node;
		this.$node.addClass( Config.COMMUNITY_NODE );

		this._id = this.$node.attr( 'id' );

		this.isFirstLoaded = false;

		// api data
		this.listData = {};

		jQuery.extend( true, Config, options );

		this.loading = new Loading( this.$node );
		this.loading.setUI();
		this.loading.show();

		// loadedComplete
		this.onLoaded = new Util.Observer();

		// parameter & hash Module - page, query, searchType, articleId
		this.paramInfo = new ParamInfo();
		this.paramInfo.setParamByUrl();

		// get viewMode - get cookie or parameter
		this.viewMode = this.getViewMode();

		// get size - get cookie or parameter
		this.size = this.getSize();

		// menu Module
		const listTopUtil = this.listTopUtil = new ListTopUtil( this.$node );
		listTopUtil.onViewMode.add( ( viewMode: any ) => {
			const pInfo = this.paramInfo;

			// It's works, If viewMode is card Mode
			if ( viewMode === 'card' ) {
				Util.setCookie( `board_${Config.board}_viewMode`, 'card' );
				pInfo.setParam( [ 'viewMode', 'card' ] );

			// It's works, If viewMode is thumbnail Mode
			} else if ( Config.board && Config.isThumbView && !Config.isListView ) {
				Util.setCookie( `board_${Config.board}_viewMode`, 'thumb' );
				pInfo.setParam( [ 'viewMode', 'thumb' ] );

			// list mode(default)
			} else {
				Util.setCookie( `board_${Config.board}_viewMode`, 'list' );
				pInfo.setParam( [ 'viewMode', 'list' ] );
			}

			// go to List page with the viewMode
			location.href = Config.listPage + '?' + pInfo.getParam();
		}, this );

		// It's works, If write Button is Clicked
		listTopUtil.onWrite.add( () => {
			const pInfo = this.paramInfo;
			if ( User.isCheckNotExistGameAccount() && GameInfo.isLogined() ) {
				Config.alert( Config.L10N.alert_not_exist_gameaccount );
			} else {
				location.href = Config.writePage + '?' + pInfo.getParamIgnore( 'query' );
			}
		}, this );

		listTopUtil.showButtonType( this.viewMode );

		// pagenavigation Module
		this.pageNavigation = new PageNavigation( this.paramInfo );

		// board search Module
		// this.search = new Search( listTopUtil.getNode(), ( query = '', searchType = '' ) => {
		this.search = new Search( $('#wrapSearch'), ( query = '', searchType = '' ) => {
			const pInfo = this.paramInfo;
            pInfo.setParam( [ 'query', encodeURIComponent( query ) ] );
            pInfo.setParam( [ 'searchType', searchType ] );
            pInfo.setParam( [ 'page', 1 ] );
            pInfo.setParam( [ 'viewMode', pInfo.getParamByKey( 'viewMode' ) ] );
            pInfo.setParam( [ 'categoryId', pInfo.getParamByKey( 'categoryId' ) ] );

			location.href = `${Config.listPage}?${pInfo.getParam().substr( 1 )}`;
		});

		this.search.onResetSearch.add( () => {
			const pInfo = this.paramInfo;

            pInfo.setParam( [ 'page', 1 ] );
            pInfo.setParam( [ 'viewMode', pInfo.getParamByKey( 'viewMode' ) ] );
            pInfo.setParam( [ 'categoryId', pInfo.getParamByKey( 'categoryId' ) ] );

            pInfo.removeParam(['query']);
            pInfo.removeParam(['searchType']);

            location.href = `${Config.listPage}?${pInfo.getParam().substr( 1 )}`;
		}, this );

		const $listCountArea = this.listTopUtil.getListSizeNode();

		if ( Config.isListCount ) {
			// let listSizeChanger = new ListSizeChanger( this.listTopUtil.getNode(), this.size );
			const listSizeChanger = new ListSizeChanger( $listCountArea, this.size );
			listSizeChanger.onChange.add( ( value: any ) => {
				this.paramInfo.setParam( [ 'size', value ] );
				this.paramInfo.setParam( [ 'page', 1 ] );
				location.href = `${Config.listPage}?${this.paramInfo.getParam().substr( 1 )}`;
				// this.getList();
			}, this );
			listSizeChanger.onInit.add( ( value: any ) => {
				// onInit
			}, this );

		} else {
			$listCountArea.hide();
		}

		this.addEvent();

		if ( Config.isArticleDelete ) {
			const articleDelete = new ArticleDelete( Config.guid );
		}

		if ( Config.isBookmarkDelete ) {
			const bookmarkDelete = new BookmarkDelete();
		}

		// @TODO test speech
		if ( Util.net( '' ) === 'opdev' ) {
			const rxJS = new RXJS();
		}
	}

	public getData() {
		return this.listData;
	}

	public get( url?: string ) {

		if ( Config.isCategory || Config.isShowCategory || Config.isShowCategory2Depth ) {
			// let _defaultCategory = Util.getParams().categoryId || GameInfo.getGameServerId();
			const _defaultCategory = Util.getParams().categoryId;

			const listCategory = new ListCategory( this.listTopUtil.getNode(), _defaultCategory || '', true, true );
			listCategory.onChange.add( ( data: any ) => {
				const pInfo = this.paramInfo;
				pInfo.setParam( [ 'categoryId', data ] );
				pInfo.setParam( [ 'page', 1 ] );
				if (pInfo.getParamByKey('searchType') === 'tag' &&  pInfo.getParamByKey('query') !== '' ) {
                    location.href = Config.listPage + '?' + pInfo.getParam();
				} else {
                    location.href = Config.listPage + '?' + pInfo.getParamIgnore('query');
				}
			});
			listCategory.onInit.add( ( categoryId: any ) => {
				const pInfo = this.paramInfo;
				pInfo.setParam( [ 'categoryId', categoryId ] );
				this.getTopNotice( categoryId );
				this.getList( categoryId );
			});
			listCategory.onNull.add( () => {
				this.getList();
			});
		} else {
			this.getTopNotice();
			this.getList();
		}
	}

	public remove() {
		jQuery( `#${this._id} .${this.listId}` ).empty();
		jQuery( `#${this._id} .pagination-container` ).remove();
	}

	private goToViewShungShung( evt: any ) {
		evt.preventDefault();
		evt.stopPropagation();

		const $this = jQuery( evt.currentTarget );
		const link = $this.find( 'a' ).attr( 'href' );

		( !Config.isListLinkTargetBlank ) ?
			location.href = link :
			window.open( link, '_blank' );
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', 'li.board-items .title', ( evt: any ) => {
			evt.preventDefault();
			this.goToViewShungShung( evt );
		});

		if ( Config.isListLinkTargetBlank ) {
			jQuery( 'body' ).on( 'click', 'li.board-items .thumb, li.board-items .desc', ( evt: any ) => {
				evt.preventDefault();
				this.goToViewShungShung( evt );
			});
		}
	}

	private getTopNotice( categoryId = '' ) {
		if ( Config.isTopNotice ) {
			const noticeList = new NoticeList( this.$node, categoryId );
			noticeList.get();
		}
	}

	// get current viewMode
	private getViewMode() {
		const pInfo = this.paramInfo;
		let viewMode = ( Config.isCardView && Config.isListView ) ? 'list' : 'card';
		viewMode = ( Config.isDefaultViewMode === 'card' ) ?
			'card' : ( Config.isThumbView && Config.isDefaultViewMode === 'thumb' ) ? 'thumb' : 'list';

		const _cookie = `board_${Config.board}_viewMode`;
		viewMode = pInfo.getParamByKey( 'viewMode' ) || Util.getCookie( _cookie ) || viewMode;
		return viewMode;
	}

	private getSize() {
		const pInfo = this.paramInfo;
		const _cookie = `board_list_count`;

		// TODO removeCookie - 17.6.12
		// let listSize = pInfo.getParamByKey( 'size' ) || Util.getCookie( _cookie ) || Config.listSize;
		let listSize = pInfo.getParamByKey( 'size' ) || Config.listSize;
		listSize = parseInt( listSize, 10 );
		listSize = ( listSize > 100 ) ? 100 : listSize;
		Util.setCookie( _cookie, listSize, '/' );
		return listSize;
	}

	private getList( categoryId?: any ) {
		const _param = Util.getParams();
		const pInfo = this.paramInfo;

		let page = _param.page || 1;
		page = pInfo.removeVag( page );
		page = parseInt( page, 10 );

		// set parameter
		pInfo.setParamByUrl();
		pInfo.setParam( ['viewMode', this.viewMode || '' ] );
		pInfo.setParam( ['size', this.size ] );

		const listAPIUrl = ( Config.board === 'all' ) ?
			Config.allList( Config.board ) : Config.list( Config.board );

		const pQuery = decodeURIComponent( pInfo.getParamByKey( 'query' ) );
		const pSearchType = pInfo.getParamByKey( 'searchType' );
		const pCategoryId = pInfo.getParamByKey( 'categoryId' ) || categoryId || '';
		const pSummary = ( pInfo.getParamByKey( 'viewMode' ) === 'card' ) ? true : false;
		const pSite = ( window as any ).userData && ( window as any ).userData.site || '';
		const pRefererSite = [ 'lineagem', 'lineage' ];
		const isReferer = ( pQuery && pSearchType && pRefererSite.indexOf( pSite ) !== -1 ) ? true : false;
		const isVote = ( Config.isVote ) ? 'true' : 'false';
		const listPromise: any = Util.get( listAPIUrl, 'GET', {
			page,
			isReferer,
			isVote,
			size: pInfo.getParamByKey( 'size' ),
			query: pQuery,
			searchType: pSearchType,
			categoryId: pCategoryId,
			summary: pSummary,
		});

		const get$ = Util.from( listPromise );
		get$.subscribe( ( data: any ) => {

			if ( !data ) {
				return;
			}

			const pInfo = this.paramInfo;
			let tmp = '';
			let searchUI = '';

			data = Util.convertCamelCase( data );

			if ( data.listArticleEntries ) {
				data.pageNavigation = data.listArticleEntries.pageNavigation;
				data.articleList = data.listArticleEntries.articleList;
			}

			// empty listNode
			this.remove();

			// set data to search Module
			this.search.setQuery( decodeURIComponent( pInfo.getParamByKey( 'query' ) ) );
			this.search.setSearchType( pInfo.getParamByKey( 'searchType' ) );

			if ( Config.isShowSearchResult ) {
				searchUI = this.search.setResultUI( data.pageNavigation.totalCount || 0 );
			}

			// empty data
			if ( data.articleList.length === 0 && !this.isFirstLoaded ) {
				if ( this.search.getQuery() && this.search.getSearchType() ) {
                    pInfo.removeParam(['query']);
                    pInfo.removeParam(['searchType']);
                    this.$node.append( Template.emptySearch(this.listId,
						Config.L10N.search_none,
						`${pInfo.getParam().substr( 1 )}`) );
				} else {
                    this.$node.append( Template.empty( this.listId, Config.L10N.list_none_article ) );
				}

				// ( this.search.getQuery() && this.search.getSearchType() ) ?
				// 	this.$node.append( Template.emptySearch( this.listId, Config.L10N.search_none,
				// 		`categoryId=${pInfo.getParamByKey( 'categoryId' )}`) ) :
				// 	this.$node.append( Template.empty( this.listId, Config.L10N.list_none_article ) );

				this.loading.hide();
				this.onLoaded.emit();

				return;
			}

			const pageUI = this.pageNavigation.setUI( data.pageNavigation );

			if ( pInfo.getParamByKey( 'query' ) && pInfo.getParamByKey( 'searchType' ) !== 'tag' ) {
                tmp = Template.searchList( data, this.listId, pInfo.getParamIgnore( 'isNotice' ) );
			} else if ( this.viewMode === 'card' && Config.isCardView ) {
				tmp = Template.cardList( data, this.listId, pInfo.getParamIgnore( 'isNotice' ) );
			} else if ( this.viewMode === 'thumb' && Config.isThumbView ) {
				tmp = Template.thumbList( data, this.listId, pInfo.getParamIgnore( 'isNotice' ) );
			} else {
				tmp = Template.list( data, this.listId, pInfo.getParamIgnore( 'isNotice' ) );
			}

			// list template + page navigation
			tmp = Util.Tmpl.join( searchUI + tmp, pageUI );

			// append template data
			this.$node.append( tmp );

			this.listData = data;

			// first loaded?
			this.isFirstLoaded = true;

			this.loading.hide();
			this.onLoaded.emit();

		}, () => {
			this.loading.hide();
			this.onLoaded.emit();
		});
	}
}

export default List;
